// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Filter1Rounded,
  Filter9PlusRounded,
  SubjectRounded,
  TextFieldsRounded,
  ToggleOnOutlined,
} from '@/constants/hardfin-standard-icons';
import { ProductFieldType } from '@/constants/product-field-type';
import { ReactNode } from 'react';

/**
 * Mapping of item field types to their corresponding Material-UI icons.
 */
const ITEM_FIELD_TYPE_ICONS: Partial<Record<ProductFieldType, ReactNode>> = {
  text: <TextFieldsRounded fontSize="small" color="inherit" />,
  multiline_text: <SubjectRounded fontSize="small" color="inherit" />,
  integer: <Filter1Rounded fontSize="small" color="inherit" />,
  number: <Filter9PlusRounded fontSize="small" color="inherit" />,
  boolean: <ToggleOnOutlined fontSize="small" color="inherit" />,
};

interface Props {
  /**
   * The type of item field to display an icon for.
   */
  type: ProductFieldType;
}

/**
 * A component that displays an icon representing an item field type.
 */
export function ItemFieldTypeIcon(props: Props) {
  return ITEM_FIELD_TYPE_ICONS[props.type];
}
